import { useThemeSwatches } from "./useThemeSwatches.js";
import ScalarThemeSwatches_default from "./ScalarThemeSwatches.vue.js";
export { ScalarThemeSwatches_default as ScalarThemeSwatches, useThemeSwatches };
